const prefix = "core-workflow-id_";

export const createContentControl = async (id = "abc-123-edf") => {
  return Word.run(async (context) => {
    const serviceTag = prefix;

    // Xóa nếu đã tồn tại
    // const exingtiServiceNameContentControl = context.document.contentControls
    //   .getByTag(serviceTag)
    //   .getFirst();
    // if (exingtiServiceNameContentControl) {
    //   exingtiServiceNameContentControl.clear();
    // }

    // Sau đó thêm mới

    // Cập nhập cho Footer
    const footer = context.document.sections.getFirst().getFooter("Primary");

    const serviceNameContentControl = footer.insertContentControl();
    serviceNameContentControl.tag = serviceTag;
    serviceNameContentControl.title =
      "Tệp này đã được trình duyệt lên hệ thống Core Workflow";
    serviceNameContentControl.appearance = "BoundingBox"; // "BoundingBox" | "Tags" | "Hidden";
    serviceNameContentControl.insertText(id, "Replace");
    serviceNameContentControl.font.color = "white";
    serviceNameContentControl.cannotEdit = true;
    serviceNameContentControl.cannotDelete = true;

    await context.sync();
  });
};
export const getContentControlText = async () => {
  const serviceTag = prefix;
  return Word.run(async (context) => {
    const contentControlsWithTag = context.document.contentControls.getByTag(
      serviceTag
    );

    // Queue a command to load the tag property for all of content controls.
    await context.load(contentControlsWithTag, "tag");

    // Synchronize the document state by executing the queued commands,
    // and return a promise to indicate task completion.
    await context.sync();
    if (contentControlsWithTag.items.length === 0) {
      console.log("No content control found.");
    } else {
      // Queue a command to get the HTML contents of the first content control.
      var firtContentControl = contentControlsWithTag.items[0];

      // Synchronize the document state by executing the queued commands,
      // and return a promise to indicate task completion.
      await context.load(firtContentControl, "text");
      await context.sync();

      return firtContentControl.text;
    }
  });
};
